
let toggleCategories = document.getElementById('toggle-categories');
if (!_.isNull(toggleCategories)) {
    toggleCategories.addEventListener('click', () => {
        let
            hiddenCategories = document.getElementsByClassName('hidden-categories'),
            showCategories = false,
            iconElement = document.getElementById('search-categories-icon');

        for (const [key, element] of Object.entries(hiddenCategories)) {
            showCategories = element.classList.toggle('d-none');

        }

        if(!showCategories) {
            toggleCategories.innerText = 'Skrýt kategorie';
            iconElement.innerText = 'expand_less';
        } else {
            toggleCategories.innerText = 'Zobrazit další kategorie';
            iconElement.innerText = 'expand_more';
        }

    })

}